export default "__VITE_ASSET__5902a514__"